import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import AdditionalServicesView from "./AdditionalServicesView";
import DomainStore from "../../../stores/CmrDomainStore";
import ServiceStore from "../../../stores/CmrServiceStore";

import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";


const elementsMap = {
  shipmentServicesOuter: ".shipment-services-outer",
  servicesSelect: ".additional-services-select"
};

export default function ShipmentLevelServicesView(el, {readOnly}={}){
  const self = this;
  const els = {};
  let additionalServicesView;

  self.init = function(){
    setElements();
    attachWidgets();
    bindElements();
    bindStores();
    renderChildren();
  };

  function setElements(){
    setElementsFromScope(els, elementsMap, el);
  }

  function attachWidgets(){
    if(!readOnly){
      els.servicesSelect.select2({
        placeholder: 'Select an option',
        data: getServiceSelectDataArray()
      });
    }
  }

  function bindElements(){
    els.servicesSelect.on("change", onAddServiceChanged);
  }

  function onAddServiceChanged(){
    onAddService({domainId: els.servicesSelect.val()});
  }
  function getServiceSelectDataArray(){
    return _(getDomains()).map((domain)=>{
      return {id: domain.id.toString(), text: domainToSelectOptionText(domain)};
    });
  }

  function domainToSelectOptionText(domain){
    return `${domain.cdm_meaning} (${CmrDomainStore.currencyToHtml(domain)})`;
  }

  function renderChildren(){
    // no need to call unbind, this view has no listeners
    // aka, it is pure
    // unbindAll([additionalServicesView]);
    additionalServicesView = renderAdditionalServicesView();
    els.shipmentServicesOuter.html(extractElements([additionalServicesView]));
  }

  function renderAdditionalServicesView(){
    const additionalServicesView = new AdditionalServicesView(null,
      {
        getDomains,
        getServices,
        onAddService,
        getAggregateCurrencyTotalViaCurrencyPerUnits,
        shouldShowServiceCloseBtn,
        shouldShowCurrencyPerUnits,
        onRemoveServiceRow,
        readOnly
      }
    );
    additionalServicesView.init();
    return additionalServicesView;
  }

  function onRemoveServiceRow(serviceId){
    // console.log(`removing asn service: ${serviceId}`);
    ServiceStore.removeServicesByIds([serviceId]);
  }

  function onAddService({domainId}){
    // console.log(`service added, domainId: ${domainId}`);

    ServiceStore.createOrUpdateServicesForAsnId(getAsnId(), {
      cdm_id: domainId
    });
  }

  function getAggregateCurrencyTotalViaCurrencyPerUnits(numb){
    return numb;
  }

  function shouldShowCurrencyPerUnits(){
    return false;
  }

  function shouldShowServiceCloseBtn(){
    return true;
  }

  function getDomains(){
    return DomainStore.getOnlyShipmentServiceLevels();
  }

  function getServices(){
    return ServiceStore.getServicesViaAsnId(getAsnId());
  }


  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", renderChildren);
    ServiceStore.bindListener("cmr_services:add", renderChildren);
    ServiceStore.bindListener("cmr_services:remove", renderChildren);
    ServiceStore.bindListener("cmr_services:change", renderChildren);
  }

  self.unbindListeners = function(){
    AsnStore.unbindListener("asns:shipping_method_changed", renderChildren);
    ServiceStore.unbindListener("cmr_services:add", renderChildren);
    ServiceStore.unbindListener("cmr_services:remove", renderChildren);
    ServiceStore.unbindListener("cmr_services:change", renderChildren);
  }

  function getAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

  function getAsnId(){
    return getAsn().id;
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/ShipmentLevelServicesView.js